import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Combo2Service, ExcelService, ReportService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "rgrnBagpending",
  templateUrl: "./rgrnBagpending.html"
})
export class rgrnBagpending implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  loadingIndicator: boolean;
  gridOptions: any;
  seasonList: any;
  colorList= [];
  orderList = [];
  seasonfinList = [];
   styleList = ["FORMAL", "CASUAL", "DAMAGE", "OLIVE", "OTHER BRANDS", "SPECIAL GOODS"];
     varietyList = [];
  backbutton: boolean;
  showIncharger: string;
  showAgent: string;
  showLine: string;
  ord_date_change: boolean = false;
  typeList = [];
  seasonyearList = [];
  menu: any;
  exceldata: any;
  totalseason_target: string;
  totalseason_order_target: string;
  date_id: any;
  year_id: any;
  seasonShow: string;
  filter = {
    rgrn_id: "",
    groupby: "rgrnWise",
    style: "",
    variety:"",
    design_no: ""
  };

  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private salesInv: SalesInvoiceService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {
    
    this.colorList = ["lightcyan", "bisque", "lightblue", "lightgoldenrodyellow", "thistle", "floralwhite", "#cc97ca", "#f2cd75", "#cec4aa", "lightblue"];
    this.typeList = ["Ordwise", "OrddesignWise"];
    this.orderList = ["ORDERED", "NON-ORDERED", "BOTH"];
    this.backbutton = false;
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
  
    this.columns = [];
   this.rgrnBagpendingReport();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };

    this.toggleCol = Object.assign({}, this.columns);
  }
  

    getVarietyList() {


    this.combo2Service.varietyStylePoCombo({ style: this.filter.style}).then((res: any) => {

      let list = [...res.data];

      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

    });

  }

  onCellClick(event) {
    console.log("celc cickeeeeeed")
    let row = event.row;
    this.backbutton = false;
    if (this.filter.groupby == "rgrnWise") {
      this.filter.rgrn_id = row.rgrn_id;
      this.filter.groupby = "rgrnShadeWise";
    }
      
    this.rgrnBagpendingReport();
  }
  onbackbutton(groupby) {

    if(this.filter.groupby == "rgrnShadeWise"){
      this.filter.rgrn_id = "";
         this.filter.groupby = "rgrnWise";
    }
  

    this.rgrnBagpendingReport();
  }

  applyFilter(){
    this.rgrnBagpendingReport();
  }

  rgrnBagpendingReport(): void {

   
    let params = {
      filter: JSON.stringify(this.filter)
    };

    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: []
    };

    this.isLoadMask = this.salesInv
      .rgrnBagpendingReport(params)
      .then(function(res: any) {
        // if (res.status) {
        //   that.showIncharger = res.sqlRes[0].inch;
        //   that.showAgent = res.sqlRes[0].agent_name;
        //   that.showLine = res.sqlRes[0].area;
        // }
        that.loadingIndicator = false;
       
        // let colorlength = that.colorList.length;
        // for(let i = 0;i < res.sqlRes.length; i++){
        //   let temp =  i % colorlength;
        //   res.sqlRes[i].background = that.colorList[temp];
        // }
        that.gridOptions = {
          columns: res.columns,
          data: res.data,
          loading: false
        };
       
        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getData(columns, data) {
    let cols = columns;
    let rows = [],
      row,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  ngOnDestroy() {
    this.salesInv;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/BaggingRackingReports/rgrnBagpending.ts